import { z } from 'zod';

export const BanksTableDefinitionZod = z.object({
    acronym: z.string().nullable(),
    fullname: z.string().nullable(),
});

export type BanksTableSchema = z.infer<typeof BanksTableDefinitionZod>;
